var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 8,
    stroke: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8334 22.5001V27.5001C30.8334 29.341 29.341 30.8334 27.5 30.8334H17.5C15.6591 30.8334 14.1667 29.341 14.1667 27.5001V17.5001C14.1667 15.6591 15.6591 14.1667 17.5 14.1667H22.5M25.572 15.8524C25.572 15.8524 25.572 17.0443 26.7639 18.2362C27.9558 19.4281 29.1477 19.4281 29.1477 19.4281M20.1289 25.8247L22.6319 25.4671C22.993 25.4156 23.3276 25.2483 23.5855 24.9904L30.3396 18.2362C30.9979 17.5779 30.9979 16.5106 30.3396 15.8524L29.1477 14.6605C28.4895 14.0022 27.4222 14.0022 26.7639 14.6605L20.0097 21.4146C19.7518 21.6725 19.5845 22.0071 19.533 22.3682L19.1754 24.8712C19.0959 25.4274 19.5727 25.9042 20.1289 25.8247Z",
    stroke: "#2E3944",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.03e89168df08b4d7e6b90a8cc78e33f9.svg";
export { ForwardRef as ReactComponent };